import { styled } from '@mui/material';
import { LegendType } from '../Chart.types';
import { ChartWrapperProps, LegendTypeDataSelector } from '../ChartWrapper';
import { ListLegend } from './list';
import { TableLegend, type TableLegendSlotProps } from './table';

export type LegendSlotProps<Datum> = {
  tableLegend?: TableLegendSlotProps<Datum>;
};

export const Legend = <Datum,>({
  data,
  legendType,
  total,
  slotProps,
}: {
  data: Datum[];
  legendType: ChartWrapperProps['legendType'];
  total?: number;
  slotProps?: LegendSlotProps<Datum>;
}) => {
  const isTable = legendType === LegendType.tableRight;
  return (
    <LegendWrapper>
      {isTable ? <TableLegend data={data} total={total} slotProps={slotProps?.tableLegend} /> : <ListLegend data={data} />}
    </LegendWrapper>
  );
};

const LegendWrapper = styled('div')({
  gridArea: 'legend',
  overflow: 'hidden',
  paddingTop: 8,
  paddingBottom: 10,
  width: '100%',
  height: '100%',

  [`${LegendTypeDataSelector[LegendType.tableRight]} &`]: {
    overflow: 'hidden',
    paddingTop: 12,
    paddingBottom: 12,
  },
});
